var DropdownItemTypes;
(function (DropdownItemTypes) {
    DropdownItemTypes["SECTION"] = "section";
    DropdownItemTypes["OPTION"] = "option";
})(DropdownItemTypes || (DropdownItemTypes = {}));

export { DropdownItemTypes };
//# sourceMappingURL=types.js.map
